<template>
  <button type="button" :class="{'hidden': disabled}" class="relative inline-flex items-center px-2 py-1 border border-gray-300 text-gray-700 bg-gray-50 hover:text-gray-500 hover:bg-white focus:outline-none">
    <slot />
  </button>
  <!--<i class="el-input__icon action" :class="[icon, disallow]" @click.prevent.stop="click"></i>-->
</template>

<script>
export default {
  name: "UiInputAction",
  props: {
    disabled: {type: Boolean, default: false},
  },

  computed: {
    disallow() {
      return this.disabled ? 'disabled' : ''
    }
  }
}
</script>

<style scoped>

</style>